var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audio',{attrs:{"id":"audio","autoplay":""}},[_c('source',{attrs:{"src":_vm.audioSrc,"type":"audio/mp3"}})])}
var staticRenderFns = []

export { render, staticRenderFns }